// extracted by mini-css-extract-plugin
export default {"p":"bd1fa691f7 bf0e812de3 b4bd121453","clr":"_1e5dcd17eb","dls":"c2eba30403"};